import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '@shared/services/translation/translation.service';

@Pipe({
  name: 'customFieldOptions',
  pure: true
})
export class CustomFieldOptionsPipe implements PipeTransform {
  constructor(
    private translation: TranslateService,
    private translationService: TranslationService
  ) { }

  // Use i18n currently loaded translation, since translations cannot be localized
  public currentLang = this.translation.currentLang;

  public transform(items: any[], lang?: any): any {
    const options = [];
    if (lang) {
      this.currentLang = lang;
    }
    items.forEach(option => {
        options.push({
            id: option.id,
            text: this.translationService.getTranslationValue(option.translations, this.currentLang)
        });
    });
    return options;
  }

}
